"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("core-js/es7/object");
var PS = require('@csod/predictive-search').PredictiveSearch;
var PredictiveSearch = (function (_super) {
    __extends(PredictiveSearch, _super);
    function PredictiveSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.reopenOnNewPredictions = function (prevProps) {
            var prev = prevProps.predictions || [];
            var next = _this.props.predictions || [];
            if (prev.length === 0 && next.length > 0 && _this.props.id) {
                var input_1 = document.getElementById(_this.props.id);
                if (input_1 && document.activeElement === input_1) {
                    input_1.blur();
                    setTimeout(function () { return input_1.focus(); }, 0);
                }
            }
        };
        _this.updateStatusMessage = function (prevProps) {
            var _a = _this.props, predictions = _a.predictions, isLoading = _a.isLoading, value = _a.value;
            if (prevProps.isLoading && !isLoading && value && value.length >= (_this.props.minPredictLength || 2)) {
                setTimeout(function () {
                    if (predictions && predictions.length > 0) {
                        _this.setState({ statusMessage: predictions.length + " " + (predictions.length === 1 ? 'suggestion' : 'suggestions') + " available" });
                    }
                    else {
                        _this.setState({ statusMessage: 'No suggestions found' });
                    }
                }, 100);
            }
            else if (!value || value.length < (_this.props.minPredictLength || 2)) {
                if (_this.state.statusMessage) {
                    _this.setState({ statusMessage: '' });
                }
            }
        };
        _this.fixAllIconsAccessibility = function () {
            var icons = document.querySelectorAll("\n        .p-icon-down-triangle,\n        .p-icon-magnifying-glass,\n        .predictor-icon,\n        [class*=\"icon\"]:not(input):not(button):not([role=\"button\"]),\n        .p-search-module [class*=\"icon\"]\n    ");
            Array.from(icons).forEach(function (icon) {
                if (icon.getAttribute("aria-hidden") === "true")
                    return;
                icon.setAttribute("tabindex", "-1");
                icon.setAttribute("aria-hidden", "true");
                if (icon.getAttribute("role") === "button" &&
                    !icon.onclick &&
                    !icon.getAttribute("data-interactive")) {
                    icon.removeAttribute("role");
                }
            });
        };
        _this.state = {
            statusMessage: ''
        };
        return _this;
    }
    PredictiveSearch.prototype.componentDidMount = function () {
        this.fixAllIconsAccessibility();
    };
    PredictiveSearch.prototype.componentDidUpdate = function (prevProps) {
        this.fixAllIconsAccessibility();
        this.updateStatusMessage(prevProps);
        this.reopenOnNewPredictions(prevProps);
    };
    PredictiveSearch.prototype.render = function () {
        var _a = this.props, id = _a.id, value = _a.value, placeholder = _a.placeholder, minPredictLength = _a.minPredictLength, maxLength = _a.maxLength, errorMessage = _a.errorMessage, isEnabled = _a.isEnabled, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, isLoading = _a.isLoading, predictions = _a.predictions, noPredictionsMessage = _a.noPredictionsMessage, searchResultsPage = _a.searchResultsPage, debounceWait = _a.debounceWait, debounceMaxWait = _a.debounceMaxWait, iconName = _a.iconName, tag = _a.tag, changeQueryToSelectedOnSelect = _a.changeQueryToSelectedOnSelect, onChange = _a.onChange, onPredict = _a.onPredict, onSelect = _a.onSelect, onSearch = _a.onSearch;
        return (React.createElement("div", null,
            React.createElement(PS, { id: id, value: value, placeholder: placeholder, minPredictLength: minPredictLength, maxLength: maxLength, errorMessage: errorMessage, isEnabled: isEnabled, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, isLoading: isLoading, predictions: predictions, noPredictionsMessage: noPredictionsMessage, searchResultsPage: searchResultsPage, debounceWait: debounceWait, debounceMaxWait: debounceMaxWait, iconName: iconName, tag: tag, changeQueryToSelectedOnSelect: changeQueryToSelectedOnSelect, onChange: onChange, onPredict: onPredict, onSelect: onSelect, onSearch: onSearch }),
            React.createElement("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", style: {
                    position: 'absolute',
                    left: '-10000px',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden'
                } }, this.state.statusMessage)));
    };
    return PredictiveSearch;
}(React.Component));
PredictiveSearch.defaultProps = {
    id: null,
    value: '',
    placeholder: null,
    minPredictLength: 2,
    maxLength: null,
    errorMessage: null,
    isEnabled: true,
    ariaLabel: null,
    ariaLabelledBy: null,
    isLoading: false,
    predictions: null,
    noPredictionsMessage: null,
    searchResultsPage: null,
    debounceWait: 500,
    debounceMaxWait: 3000,
    iconName: 'magnifying-glass',
    tag: null,
    changeQueryToSelectedOnSelect: true
};
exports.PredictiveSearch = PredictiveSearch;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PredictiveSearch"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/PredictiveSearch/PredictiveSearch.js
// module id = 255
// module chunks = 0